import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/AvatarSelect.desktop';
import { MobileView } from './mobile/AvatarSelect.mobile';
import { ChildProfilePageStep, CommonPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppAuthentication,
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';

export const AvatarSelect = (): JSX.Element => {
  // Redux Hooks
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);

  return <React.Fragment>{<DesktopView />}</React.Fragment>;
};
